<template>
  <div>
    <div class="row-margin">
      <slot name="list-info">
        共<span class="text-danger">{{ pageInfo.total }}</span>条记录
      </slot>
    </div>
    <hy-list class="list" :list="list" :loading="loading" :page-info="pageInfo" @current-change="handleCurrentChange">
      <slot></slot>
    </hy-list>
  </div>
</template>

<script>
export default {
  name: 'FwList',
  props: {
    list: {
      type: Array,
      required: true,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageInfo: {
      type: Object,
      required: true,
      default: () => ({
        total: 0,
        pageSize: 0,
        currentPage: 1
      })
    }
  },
  data: () => ({}),
  methods: {
    handleCurrentChange (val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style scoped>
  .list {
    margin: 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/FwList.vue